import React from "react";
import {LocalStorageNames} from "ubcommunity-shared/src/constants";
import {SSO_FLOWS} from "ubcommunity-shared/src/Auth/SSO/auth-ui/types";
import {SSOHandleAuth} from "ubcommunity-shared/src/Auth/SSO/SSOHandleAuth";
import {useAsyncLocalStorage} from "ubcommunity-shared/src/Auth/AuthProvider/useAsyncLocalStorage";
import SSOLogin from "../SSOLogin/SSOLogin";

export const SSO = () => {
    const {value} = useAsyncLocalStorage(LocalStorageNames.SSO_FLOW, undefined);

    if (value?.flow === SSO_FLOWS.SOCIAL) {
        return <SSOHandleAuth />;
    }

    return <SSOLogin />;
};
